import { render, staticRenderFns } from "./RatiosEmplois.vue?vue&type=template&id=60f65a7b&"
import script from "./RatiosEmplois.vue?vue&type=script&lang=js&"
export * from "./RatiosEmplois.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports